<template>
  <div>Callback...</div>
</template>

<script>
import userManager from '../oidc-config';

export default {
  mounted() {
    userManager.signinRedirectCallback().then(() => {
      this.$router.push({ path: '/admin' });
    }).catch((err) => {
      console.error(err);
    });
  }
};
</script>
